import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

export interface ExamCreatePageState {
  type: string;
  complement: string;
  region: string;
  institution: string;
  year: string;
  loading: boolean;
}

export interface ExamCreatePageSetStatePayload {
  name: keyof ExamCreatePageState;
  value: string | string[] | boolean;
}

export const createExamInitialState: ExamCreatePageState = {
  type: '',
  complement: '',
  region: '',
  institution: '',
  year: '',
  // Estados não persistentes
  loading: false,
};

const { reducer, actions } = createSlice({
  name: 'examCreatePage',
  initialState: createExamInitialState,
  reducers: {
    setState: (state, action: PayloadAction<ExamCreatePageSetStatePayload>): ExamCreatePageState => {
      const { name, value } = action.payload;
      if (state[name] === value) {
        return state;
      }
      const nextState = { ...state, [name]: value };
      switch (name) {
        case 'type':
          nextState.complement = '';
          nextState.region = '';
          nextState.institution = '';
          nextState.year = '';
          break;
        case 'complement':
          nextState.region = '';
          nextState.institution = '';
          nextState.year = '';
          break;
        case 'region':
          nextState.institution = '';
          nextState.year = '';
          break;
        case 'institution':
          nextState.year = '';
          break;
        default:
      }
      return nextState;
    },
    reset: (): ExamCreatePageState => ({
      ...createExamInitialState,
    }),
    setLoading: (
      state,
      action: PayloadAction<boolean>,
    ): ExamCreatePageState => {
      const loading = action.payload;
      return { ...state, loading };
    },
  },
});

const persistentReducer = persistReducer({
  key: 'examCreatePage',
  storage,
  blacklist: [
    'loading',
  ],
}, reducer);

export { actions };
export default persistentReducer;
